/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type TasksControllerListTasksV1SortBy = typeof TasksControllerListTasksV1SortBy[keyof typeof TasksControllerListTasksV1SortBy];


export const TasksControllerListTasksV1SortBy = {
  manual: 'manual',
  dueDate: 'dueDate',
  recent: 'recent',
  updated: 'updated',
  title: 'title',
  priority: 'priority',
} as const;
